/*
 * 国际化配置
 * @Author: sunxiaodong
 * @Date: 2018-12-06 14:03:43
 * @Last Modified by: sunxiaodong
 * @Last Modified time: 2018-12-07 16:17:32
 */

// element-ui lang
import elementEnLocale from "element-ui/lib/locale/lang/en";
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";
// private lang
import enPrivate from "_private/config/lang/en";
import zhPrivate from "_private/config/lang/zh";
// individuation lang
import enIndividuation from "@/lang/en";
import zhIndividuation from "@/lang/zh";
// import individuationConfig from "@/individuation.config";

const object = require("lodash/fp/object");
// merge private lang and individuation lang
const enLocale = object.merge(enPrivate, enIndividuation);
const zhLocale = object.merge(zhPrivate, zhIndividuation);
const locale =
    $GLOBAL_CONFIG.i18n && $GLOBAL_CONFIG.i18n.locale
        ? $GLOBAL_CONFIG.i18n.locale
        : "zh";

const messages = {
    en: {
        ...enLocale,
        ...elementEnLocale
    },
    zh: {
        ...zhLocale,
        ...elementZhLocale
    }
};
export default {messages, locale};
